import { TagElement, TagsDirectory } from '@core/domain/mappers/assistants/tags.directory';
import { StateTagType } from '@shared/ui-components/state-tag/models/tag.model';
import { InvoiceClaimLevel, InvoiceStatusCode } from '@core/domain/model/invoices/my-invoices-listing.model';

export class TagTransformer {
  public static tagTypeFromCode(code: string, element: TagElement): StateTagType {
    return TagsDirectory[element]?.[code] ?? TagsDirectory[element]?.['default'];
  }
  public static tagFromInvoice(
    statusCode: InvoiceStatusCode,
    claimLevel: InvoiceClaimLevel,
    claimStopped: boolean,
    isGGCC: boolean
  ): {
    description: string;
    tag: StateTagType;
  } | null {
    if (statusCode === InvoiceStatusCode.PAID || statusCode === InvoiceStatusCode.PAID_INACTIVE) {
      return {
        description: 'INVOICES.STATUS.PAID',
        tag: 'completed',
      };
    }
    if (statusCode === InvoiceStatusCode.PREPAID || statusCode === InvoiceStatusCode.PREPAID_INACTIVE) {
      return {
        description: 'INVOICES.STATUS.PREPAID',
        tag: 'completed',
      };
    }
    if (isGGCC && claimLevel != null) {
      return {
        description: 'INVOICES.STATUS.PENDING_PAYMENT',
        tag: 'pending',
      };
    }
    if (claimLevel === InvoiceClaimLevel.N3) {
      return TagTransformer._invoiceClaimLevel3(statusCode, claimStopped);
    }
    if (claimLevel != null) {
      return TagTransformer._invoiceClaimLevel1Or2(statusCode, claimStopped);
    }
    switch (statusCode) {
      case InvoiceStatusCode.PENDING_PAYMENT:
      case InvoiceStatusCode.OVERDUE:
      case InvoiceStatusCode.RETURNED:
      case InvoiceStatusCode.CONTESTED:
        return {
          description: 'INVOICES.STATUS.PENDING_PAYMENT',
          tag: 'pending',
        };
    }
    return null;
  }
  private static _invoiceClaimLevel3(
    statusCode: InvoiceStatusCode,
    claimStopped: boolean
  ): { description: string; tag: StateTagType } | null {
    switch (statusCode) {
      case InvoiceStatusCode.PENDING_PAYMENT:
      case InvoiceStatusCode.OVERDUE:
      case InvoiceStatusCode.RETURNED:
        return claimStopped
          ? {
              description: 'INVOICES.STATUS.PENDING_PAYMENT',
              tag: 'pending',
            }
          : {
              description: 'INVOICES.STATUS.NON_PAYMENT_NOTICE',
              tag: 'admin',
            };
    }
    return null;
  }
  private static _invoiceClaimLevel1Or2(
    statusCode: InvoiceStatusCode,
    claimStopped: boolean
  ): { description: string; tag: StateTagType } | null {
    switch (statusCode) {
      case InvoiceStatusCode.CONTESTED:
        return {
          description: 'INVOICES.STATUS.NON_PAYMENT_NOTICE',
          tag: 'admin',
        };
      case InvoiceStatusCode.PENDING_PAYMENT:
      case InvoiceStatusCode.OVERDUE:
      case InvoiceStatusCode.RETURNED:
        return claimStopped
          ? {
              description: 'INVOICES.STATUS.PENDING_PAYMENT',
              tag: 'pending',
            }
          : {
              description: 'INVOICES.STATUS.NON_PAYMENT_NOTICE',
              tag: 'admin',
            };
    }
    return null;
  }
}
